import React from "react";
import { MdArrowLeft, MdArrowRight } from "react-icons/md";

const Pagination = ({ itemsPage, totalPages, handlePageChange }) => {
  // Helper function to generate page numbers with ellipsis
  const generatePageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 2; // Number of pages to show around the current page

    // Always show the first page
    pages.push(1);

    // Show ellipsis if current page is far from the start
    if (itemsPage > maxPagesToShow + 2) {
      pages.push("...");
    }

    // Calculate the range of pages to show around the current page
    const startPage = Math.max(2, itemsPage - maxPagesToShow);
    const endPage = Math.min(totalPages - 1, itemsPage + maxPagesToShow);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    // Show ellipsis if current page is far from the end
    if (itemsPage < totalPages - (maxPagesToShow + 1)) {
      pages.push("...");
    }

    // Always show the last page if there's more than one page
    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <nav>
      <div className="row mx-0 align-items-center">
        <div className="col-lg-12 text-left px-0">
          <ul className="pagination">
            {/* Previous Button */}
            <li className={`page-item ${itemsPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => handlePageChange((prev) => Math.max(prev - 1, 1))}
                disabled={itemsPage === 1}
                aria-label="Previous"
              >
                <MdArrowLeft />
              </button>
            </li>

            {/* Page Numbers */}
            {generatePageNumbers().map((page, index) => (
              <li
                key={index}
                className={`page-item ${
                  page === itemsPage ? "active" : ""
                } ${page === "..." ? "disabled" : ""}`}
              >
                {page === "..." ? (
                  <span className="page-link">...</span>
                ) : (
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(page)}
                    aria-label={`Page ${page}`}
                  >
                    {page}
                  </button>
                )}
              </li>
            ))}

            {/* Next Button */}
            <li
              className={`page-item ${
                itemsPage === totalPages ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() =>
                  handlePageChange((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={itemsPage === totalPages}
                aria-label="Next"
              >
                <MdArrowRight />
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Pagination;